import React, { useState } from "react";
import { toast } from "sonner";
import { EnvelopeSimple } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "../../lib/api";

export const BOOKINGS_EMAIL = "enquiries@camcpc.co.uk";
const input = "w-full rounded-sm border border-stone-300 bg-white px-3 py-2 text-sm";

export const OfflineConsultant = ({ consultant }) => {
  const [f, setF] = useState({ full_name: "", email: "", phone: "", reason: "", consent: false });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: k === "consent" ? e.target.checked : e.target.value });
  const submit = (e) => {
    e.preventDefault();
    setBusy(true);
    api.post("/enquiries", { ...f, reason: f.reason || "Appointment request", preferred_consultant: consultant.slug, payment_type: "self_pay" })
      .then(() => { setSent(true); toast.success("Thanks - Beverley will be in touch."); })
      .catch((err) => toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message)).finally(() => setBusy(false));
  };
  return (
    <section data-testid="offline-consultant" className="bg-cream-100 border border-bronze-light/50 rounded-md p-6 space-y-4">
      <h2 className="font-serif text-2xl">Appointments with {consultant.name}</h2>
      <p className="text-sm text-ink-muted leading-relaxed">
        {consultant.name}&apos;s appointments can&apos;t be booked or paid for online. Please contact Beverley, who arranges his clinic, and she&apos;ll find you a time.
        Any tests he recommends (such as an echo, ABPM or Holter monitoring) can then be booked and paid for through this website - Beverley will email you a secure link.
      </p>
      <a href={`mailto:${BOOKINGS_EMAIL}?subject=${encodeURIComponent(`Appointment with ${consultant.name}`)}`} data-testid="offline-consultant-email"
        className="btn-primary inline-flex items-center gap-2"><EnvelopeSimple size={16} /> Email {BOOKINGS_EMAIL}</a>
      {sent ? (
        <p data-testid="offline-consultant-sent" className="text-sm font-medium">Thank you - your request has been sent to Beverley and the clinic team. We&apos;ll reply by email or phone.</p>
      ) : (
        <form onSubmit={submit} className="space-y-3 pt-2 border-t border-bronze-light/40" data-testid="offline-consultant-form">
          <p className="text-sm font-medium pt-3">Or send a quick request</p>
          <div className="grid sm:grid-cols-3 gap-3">
            {[["full_name", "Full name", "text"], ["email", "Email", "email"], ["phone", "Phone", "tel"]].map(([k, l, t]) => (
              <label key={k} className="text-sm">{l}<input required type={t} value={f[k]} onChange={set(k)} className={input} data-testid={`offline-${k}`} /></label>
            ))}
          </div>
          <label className="text-sm block">Preferred days or times (optional)
            <textarea rows={2} value={f.reason} onChange={set("reason")} maxLength={1000} className={input} data-testid="offline-reason"
              placeholder="Please don't include medical details" /></label>
          <label className="flex items-start gap-2 text-xs text-ink-muted">
            <input type="checkbox" required checked={f.consent} onChange={set("consent")} className="mt-0.5 accent-[#8C6643]" data-testid="offline-consent" />
            I agree to the clinic using these details to contact me about my appointment (see our Privacy Notice).
          </label>
          <button type="submit" disabled={busy} className="btn-secondary" data-testid="offline-submit">{busy ? "Sending…" : "Send request"}</button>
        </form>
      )}
    </section>
  );
};
